import React, {useState} from 'react';
import {BoardForm, BreadCrumb} from '../../../Components/Template';
import {firstProps, initialRefundState, initialState} from './data';
import {setForm} from '../../../util';
import {postBoard} from '../../../api/board';
import {Container} from '../../../Components/Atom';

const categoryMap = {
	자유: '자유게시판',
	홍보: '홍보게시판',
	환불: '환불게시판',
	공지: '공지게시판',
	사진: '사진게시판',
	기록: '기록게시판',
};

const BoardWrite = ({category = '자유'}) => {
	const [state, setState] = useState(
		category === '환불' ? initialRefundState : initialState,
	);
	const [file, setFile] = useState();
	const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;
	firstProps.inputs.forEach((input) => {
		setForm(input, state, setState);
	});
	firstProps.writeBtn.onClick = async () => {
		if (category === '환불' && state.password.length === 0) {
			return alert('환불게시판은 반드시 비밀번호를 설정해 주세요.');
		}
		if (!state.title || !state.content) {
			if (!state.title && !state.content) {
				return alert('제목과 내용을 입력해 주세요.');
			} else if (!state.title) {
				return alert('제목을 입력해 주세요.');
			} else {
				return alert('내용을 입력해 주세요.');
			}
		}
		let res = await postBoard({...state, category, files: [file]});

		if (res.isSuccess) {
			window.location.href = window.location.href.split('-create')?.[0];
		}
	};

	firstProps.fileInput.file.onChange = (e) => {
		// setFile(e.target.files[0])
		const selectedFile = e.target.files[0];
		if (selectedFile) {
			if (selectedFile.size > MAX_FILE_SIZE_BYTES) {
				alert('첨부파일 제한 용량은 2MB 이하입니다.');
				e.target.value = null; 
				setFile(null); 
				return;
			}
			setFile(selectedFile);
		} else {
			setFile(null);
		}
	};
	firstProps.fileInput.file.fileName = file?.name;
	return (
		<Container>
			<BreadCrumb depths={['HOME', '참여마당', categoryMap[category]]} />
			<BoardForm {...firstProps} category={category} />
		</Container>
	);
};

export default BoardWrite;
